import { useState } from "react";
import { Sparkles } from "lucide-react";

import { capture } from "@/lib/posthog";
import { AiChatModal } from "@/components/gating/UpsellModals";

/**
 * Botón flotante del chat con IA. La función aún no existe: el botón cuenta qué
 * será y deriva a ventas. Se oculta bajo `lg`, donde el pie lo ocupa la tab bar
 * de navegación.
 */
export function AiChatButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        aria-label="Chatear con IA"
        onClick={() => {
          capture("ai_chat_clicked");
          setOpen(true);
        }}
        className="fixed bottom-6 right-6 z-30 hidden h-14 w-14 items-center justify-center rounded-full border border-slate-100 bg-white shadow-lg shadow-slate-900/10 transition-colors hover:bg-accent lg:flex dark:border-slate-800 dark:bg-slate-900 dark:shadow-black/40"
      >
        <Sparkles className="h-6 w-6 text-emerald-500" />
      </button>

      <AiChatModal open={open} onOpenChange={setOpen} />
    </>
  );
}
